import React from 'react';
import './ModalButton.css';
import {REGISTRY_SINGLETON} from "../../../../scenes/Registry";

const ModalButton = ({onClick, className, text, noSound, style, children, disabled, title}) => {
  const finalOnClick = () => {
    if (disabled) {
      return;
    }
    if(!noSound) {
      REGISTRY_SINGLETON.getSoundManager().playMenuButtonClick();
    }
    onClick && onClick();
  }

  return (
    <button
      onClick={finalOnClick}
      className={`standard-button ${className}`}
      style={style}
      disabled={disabled}
      title={title}
    >
      {children ?
        children :
        <h2>{text}</h2>
      }
    </button>
  );
};

export default ModalButton;
